import * as React from "react";
import {
    SecondaryActionButton,
    LinkoutButtonText,
} from "./PostActionButtons.styles";
import { Stack } from "@mui/material";
import { ChevronRightIcon } from "@icons/ChevronRightIcon";
import { TEXT_ELLIPSIS } from "../../../Shared/styles";
import { LinkSolidIcon } from "@icons/LinkSolidIcon";
import { useCommunityNavigation } from "@infrastructure/Hooks/useCommunityNavigation";

export function LinkoutButton({
    linkoutUrl,
    textColor,
    backgroundColor,
    rightIconColor,
    leftIconColor,
}: {
    linkoutUrl: string;
    backgroundColor?: string;
    leftIconColor?: string;
    rightIconColor?: string;
    textColor?: string;
}) {
    const { navigateTo } = useCommunityNavigation();
    const getUrlHost = (url: string) => {
        return new URL(url).hostname;
    };

    return (
        <SecondaryActionButton
            disableRipple
            onClick={(e) => {
                e.stopPropagation();
                navigateTo(linkoutUrl);
            }}
            endIcon={
                <ChevronRightIcon
                    color={
                        rightIconColor || "var(--community-color-snow-white)"
                    }
                />
            }
            style={{ backgroundColor: backgroundColor }}
        >
            <Stack
                alignItems="center"
                justifyContent="center"
                sx={{
                    width: "40px",
                }}
            >
                <LinkSolidIcon
                    color={leftIconColor || "var(--community-color-snow-white)"}
                    width="16px"
                    height="16px"
                />
            </Stack>
            <Stack
                sx={{ minWidth: 0, ...TEXT_ELLIPSIS }}
                flex="1"
                alignItems="flex-start"
            >
                <LinkoutButtonText
                    style={{
                        color: textColor || "var(--community-color-snow-white)",
                    }}
                >
                    {getUrlHost(linkoutUrl)}
                </LinkoutButtonText>
            </Stack>
        </SecondaryActionButton>
    );
}
